import { FC, useState } from 'react'
import { NewHeader } from 'components/page-header'
import { Table } from '../components/Table'
import { useCorrections } from '@hooks/useCorrections'
import { useTranslation } from 'react-i18next'
import { ValuePicker } from 'components/tables/column-filters'
import { CorrectionActionFilter } from 'types'

export const CorrectionsQueue: FC = () => {
  const [status, setStatus] = useState<CorrectionActionFilter>(
    CorrectionActionFilter.Pending,
  )
  const correctionsQuery = useCorrections(status)
  const { t } = useTranslation()

  const statusFilterLabel = {
    [CorrectionActionFilter.All]: t('common.all'),
    [CorrectionActionFilter.Completed]: t(
      'features.correctionsQueue.completed',
    ),
    [CorrectionActionFilter.NotRequired]: t(
      'features.correctionsQueue.notRequired',
    ),
    [CorrectionActionFilter.Pending]: t('features.correctionsQueue.pending'),
  }

  const corrections =
    correctionsQuery.data?.pages.flatMap((page) => page.data) ?? []
  const count = correctionsQuery.data?.pages.at(0)?.meta?.total ?? 0

  return (
    <div className="flex flex-grow">
      <div className="flex flex-col flex-grow">
        <NewHeader title="Corrections Queue" />
        <h2 className="text-lg font-medium text-neutral-900 px-8 mt-4 mb-3">
          {t('features.correctionsQueue.correctionsCount', { count })}
        </h2>
        <Table
          corrections={corrections}
          hasNextPage={correctionsQuery.hasNextPage ?? false}
          isFetchingNextPage={correctionsQuery.isFetchingNextPage}
          loading={correctionsQuery.isLoading}
          onNextPage={() => {
            void correctionsQuery.fetchNextPage()
          }}
          status={status}
          statusFilterComponent={
            <ValuePicker
              accessor={(v) => v}
              columnNameTranslationKey="common.status"
              onChange={(v) => {
                const status = Array.from(v).at(0)
                if (!status)
                  throw new Error(
                    'Unreachable. with multiSelect off, there should always be something chosen',
                  )

                setStatus(status)
              }}
              renderLabel={(v) => statusFilterLabel[v]}
              selected={new Set([status])}
              triggerLabel={statusFilterLabel[status]}
              values={Object.values(CorrectionActionFilter)}
              multiSelect={false}
            />
          }
        />
      </div>
    </div>
  )
}
